/**
 * @generated SignedSource<<2a36c1e2216ec6789bde3d4acc62d146>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: nx generate-api-types
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type AcknowledgeUKRiskWarningMutation$variables = {
  identifier: string;
};
export type AcknowledgeUKRiskWarningMutation$data = {
  readonly acknowledgeUKRiskWarning: boolean | null | undefined;
};
export type AcknowledgeUKRiskWarningMutation = {
  response: AcknowledgeUKRiskWarningMutation$data;
  variables: AcknowledgeUKRiskWarningMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "identifier"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "identifier",
        "variableName": "identifier"
      }
    ],
    "kind": "ScalarField",
    "name": "acknowledgeUKRiskWarning",
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "AcknowledgeUKRiskWarningMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "AcknowledgeUKRiskWarningMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "54c8ff6bf560afa66ae35f1e1527604d",
    "id": null,
    "metadata": {},
    "name": "AcknowledgeUKRiskWarningMutation",
    "operationKind": "mutation",
    "text": "mutation AcknowledgeUKRiskWarningMutation(\n  $identifier: String!\n) {\n  acknowledgeUKRiskWarning(identifier: $identifier)\n}\n"
  }
};
})();

(node as any).hash = "6a094687cdd4a00372be9cb107dc72b4";

export default node;
